import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface I18nReadyCheckerProps {
  children: ReactNode;
}

// Внутренний компонент, который проверяет готовность i18n
const I18nReadyChecker: React.FC<I18nReadyCheckerProps> = ({ children }) => {
  const { i18n, t } = useTranslation();
  const [isInitialized, setIsInitialized] = useState(i18n.isInitialized);

  useEffect(() => {
    if (!i18n.isInitialized) {
      const handleInitialized = () => {
        setIsInitialized(true);
      };

      // Проверяем, не инициализирована ли уже система
      if (i18n.isInitialized) {
        setIsInitialized(true);
      } else {
        // Если нет, подписываемся на событие инициализации
        i18n.on('initialized', handleInitialized);
        
        // Очищаем подписку при размонтировании
        return () => {
          i18n.off('initialized', handleInitialized);
        };
      }
    } else {
      setIsInitialized(true);
    }
  }, [i18n]);

  // Пока i18n не инициализирована, показываем индикатор загрузки
  if (!isInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>{t('loading_translations')}</div>
      </div>
    );
  }

  return <>{children}</>;
};

const I18nProviderWrapper: React.FC<I18nReadyCheckerProps> = ({ children }) => {
  return <I18nReadyChecker>{children}</I18nReadyChecker>;
};

export default I18nProviderWrapper;